import React, {Component} from 'react';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import ReactTooltip from 'react-tooltip';
import {Tabs, Tab} from 'react-bootstrap';
import '../scss/_smartrange.scss';



export default class SmartRange extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cssClass: props.cssClass || 'aft-smartrange',
      minValues: props.minValues || [],
      maxValues: props.maxValues || [],
      placeholder: props.placeholder || 'Any',
      minPlaceholder: props.minPlaceholder || 'Minimum',
      maxPlaceholder: props.maxPlaceholder || 'Maximum',
      minAttribute: props.minAttribute || 'data-minimum',
      maxAttribute: props.maxAttribute || 'data-maximum',
      minHintText: props.minHintText || '',
      maxHintText: props.maxHintText || '',
      noMinHintText: props.noMinHintText || 'No Min',
      noMaxHintText: props.noMaxHintText || 'No Max',
      readonly: props.readonly || true,
      format: props.format || true,
      preffixText: props.preffixText || '',
      minimumItemValue: props.minimumItemValue || '', 
      maximumItemValue: props.maximumItemValue || '',
      minObj: null,
      maxObj: null,
      leftItemsObj: null,
      rightItemsObj: null,
      minOldVal: props.minimumItemValue || '', 
      minNewVal: '',
      maxOldVal: props.maximumItemValue || '',
      maxNewVal: '',
      targetValue: '',
      showItems: 'left',

      multiTabs: props.multiTabs || false,
      activeTabKey: props.activeTabKey || 1,
      showTooltip: false,
    };

    this.formatNumber = this.formatNumber.bind(this);
    this.isNumber = this.isNumber.bind(this);
    this.minChanged = this.minChanged.bind(this);
    this.maxChanged = this.maxChanged.bind(this);
    this.setTargetValue = this.setTargetValue.bind(this);
    this.minItemsClickHandler = this.minItemsClickHandler.bind(this);
    this.maxItemsClickHandler = this.maxItemsClickHandler.bind(this);
    this.openPopup = this.openPopup.bind(this);
    this.callCallbackFunctions = this.callCallbackFunctions.bind(this);
    this.kFormatter = this.kFormatter.bind(this);

    this.onTabSelect = this.onTabSelect.bind(this);
    this.showHideTooltip = this.showHideTooltip.bind(this);
    
  }

  componentDidMount() {
    if(!Array.isArray(this.state.minValues)) {
      console.log('Minimum values is not Array');
    }
    if(!Array.isArray(this.state.maxValues)) {
      console.log('Maximum values is not Array');
    }    
    this.onTabSelect(this.state.activeTabKey, true);    
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.minimumItemValue !== nextProps.minimumItemValue){
      this.setState({minimumItemValue: nextProps.minimumItemValue},() => {
        this.setTargetValue();
      });
    }
    if(this.props.maximumItemValue !== nextProps.maximumItemValue){
      this.setState({maximumItemValue: nextProps.maximumItemValue},() => {
        this.setTargetValue();
      });
    }    
    if(this.props.activeTabKey !== nextProps.activeTabKey){
      this.onTabSelect(nextProps.activeTabKey, true);
    }
    if(this.props.secondMinimumItemValue !== nextProps.secondMinimumItemValue && 
      nextProps.multiTabs /* && this.props.activeTabKey !== nextProps.activeTabKey */){
      if(nextProps.activeTabKey === 2){
        this.setState({minimumItemValue: nextProps.secondMinimumItemValue},() => {
          this.setTargetValue();
        });
      }        
    }
    if(this.props.secondMaximumItemValue !== nextProps.secondMaximumItemValue && 
      nextProps.multiTabs /* && this.props.activeTabKey !== nextProps.activeTabKey */){
      if(nextProps.activeTabKey === 2){
        this.setState({maximumItemValue: nextProps.secondMaximumItemValue},() => {
          this.setTargetValue();
        });
      }        
    }    
  }

  formatNumber(number,n, x) {
    if(this.state.format) {
        var re = '\\d(?=(\\d{' + (x || 8) + '})+' + (n > 0 ? '\\.' : '$') + ')';
        number = parseInt(number,10);
        number = number.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    }
    return number;
  };

  kFormatter(num) {
    return num > 999 ? (Math.trunc(((num/1000))*10)/10).toString().replace(/\.0$/, '') + 'k' : num
  }

  //check text inputs for numbers only
  isNumber(e) {
    // Allow: backspace, delete, tab, escape, enter and .
    //if (([46, 8, 9, 27, 13, 110, 190].includes(e.keyCode)) ||
    if (([46, 8, 9, 27, 13].includes(e.keyCode)) ||
        // Allow: Ctrl/cmd+A
        (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: Ctrl/cmd+C
        (e.keyCode === 67 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: Ctrl/cmd+X
        (e.keyCode === 88 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)) {
        // let it happen, don't do anything
        return;
    }
    //Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault();
    }
  }

  minChanged(e) {
    var self = this;
    var minNewVal = e.target.value;
    if (minNewVal) {
      minNewVal = minNewVal.replace(/,/g,'').replace(/\$/g,'');
    }
    self.setState({minimumItemValue: minNewVal}, () => {
      self.setTargetValue();
    });  
  }

  maxChanged(e) {
    var self = this;
    var maxNewVal = e.target.value;
    if (maxNewVal) {
      maxNewVal = maxNewVal.replace(/,/g,'').replace(/\$/g,'');
    }
    self.setState({maximumItemValue: maxNewVal}, () => {
      self.setTargetValue();
    });
  }

  setTargetValue() {
    var value = this.state.placeholder;
    if(this.state.minimumItemValue && this.state.minimumItemValue !== '' && 
      this.state.maximumItemValue && this.state.maximumItemValue !== '' && 
      this.state.minimumItemValue >= 0 && this.state.maximumItemValue >= 0) {
      value = this.state.preffixText + this.state.minHintText + '' + this.kFormatter(this.state.minimumItemValue) + ' - ' + this.state.maxHintText + '' + this.kFormatter(this.state.maximumItemValue);
    } 
    else if(this.state.minimumItemValue && this.state.minimumItemValue !== '' && this.state.minimumItemValue >= 0) {
      value = this.state.preffixText + this.state.minHintText + '' + this.kFormatter(this.state.minimumItemValue) + ' - ' + this.state.noMaxHintText;
    } 
    else if(this.state.maximumItemValue && this.state.maximumItemValue !== '' && this.state.maximumItemValue >= 0) {
      value = this.state.preffixText + this.state.noMinHintText + ' - ' + this.state.maxHintText + '' + this.kFormatter(this.state.maximumItemValue);
    }
    this.setState({targetValue: value});
  }

  showListItems(position){
    if(position && position !== ""){
      this.setState({showItems: position});
    }
  }

  minItemsClickHandler(e) {
    var self = this;
    var minVal = e.target.value;
    var maxVal = self.state.maximumItemValue;
    var maxOldVal = self.state.maximumItemValue;
    if(minVal === 0) minVal = '';
    if(minVal !== '' && maxVal && maxVal !== '' && parseInt(minVal,10) > parseInt(maxVal,10)){
      maxVal = '';
    }
    self.setState({minimumItemValue: minVal, maximumItemValue: maxVal}, () => {
      if(self.props.minimumCallback) self.props.minimumCallback(minVal);
      if(maxOldVal !== maxVal && self.props.maximumCallback) self.props.maximumCallback(maxVal);
      if(self.props.multiTabs && parseInt(self.state.activeTabKey,10) === 2){
        if(self.props.handleSecondSmartRangeValueChange) self.props.handleSecondSmartRangeValueChange(minVal, maxVal);
      }
      else{
        if(self.props.handleSmartRangeValueChange) self.props.handleSmartRangeValueChange(minVal, maxVal);
      }
      self.setTargetValue();
      if(this.maximumInputRef){
         /*this.maximumInputRef.focus();
        this.maximumInputRef.select(); */
      }
    });
  }

  maxItemsClickHandler(e) {
    var self = this;
    var maxVal = e.target.value;
    if(maxVal === 0) maxVal = '';
    self.setState({maximumItemValue: maxVal}, () => {
      if(self.props.maximumCallback) self.props.maximumCallback(maxVal);
      if(self.props.multiTabs && parseInt(self.state.activeTabKey,10) === 2){
        if(self.props.handleSecondSmartRangeValueChange) self.props.handleSecondSmartRangeValueChange(self.state.minimumItemValue, maxVal);
      }
      else{
        if(self.props.handleSmartRangeValueChange) self.props.handleSmartRangeValueChange(self.state.minimumItemValue, maxVal);
      }
      self.setTargetValue();      
    });
  }

  openPopup(){
    if(this.minimumInputRef){
      this.minimumInputRef.focus();
      /* this.minimumInputRef.select(); */
    } 
  }

  showHideTooltip() {
    this.setState({showTooltip: !this.state.showTooltip});
  }


  callCallbackFunctions(e){
    var minOldVal = this.state.minOldVal;
    var minimumItemValue = this.state.minimumItemValue;
    var maxOldVal = this.state.maxOldVal;
    var maximumItemValue = this.state.maximumItemValue;    
    
    if(minimumItemValue && minimumItemValue !== "" && maximumItemValue && maximumItemValue !== ""){
      if(parseInt(minimumItemValue,10) > parseInt(maximumItemValue,10)){
        if(e === 'min'){
          maximumItemValue = '';
        }
        else{
          minimumItemValue = '';
        }
      }      
    }
    this.setState({minimumItemValue: minimumItemValue, minOldVal: minimumItemValue, maximumItemValue: maximumItemValue, maxOldVal: maximumItemValue});
    if(this.props.minimumCallback && minimumItemValue !== minOldVal){      
      this.props.minimumCallback(minimumItemValue);
    }
    if(this.props.maximumCallback && maximumItemValue !== maxOldVal){
      this.props.maximumCallback(maximumItemValue);
    }
    if(this.props.multiTabs && parseInt(this.state.activeTabKey,10) === 2){
      if(this.props.handleSecondSmartRangeValueChange && (minimumItemValue !== minOldVal || maximumItemValue !== maxOldVal)){      
        this.props.handleSecondSmartRangeValueChange(minimumItemValue,maximumItemValue);
      }
    }
    else{
      if(this.props.handleSmartRangeValueChange && (minimumItemValue !== minOldVal || maximumItemValue !== maxOldVal)){      
        this.props.handleSmartRangeValueChange(minimumItemValue,maximumItemValue);
      }
    }
  }

  onTabSelect(eventKey, callSetTarget){    
    if(this.state.multiTabs){
      var state = Object.assign({}, this.state);
      if(parseInt(eventKey,10) === 1){
        state.minValues = this.props.minValues || [];
        state.maxValues = this.props.maxValues || [];
        state.placeholder = this.props.placeholder || 'Any';
        state.minPlaceholder = this.props.minPlaceholder || 'Minimum';
        state.maxPlaceholder = this.props.maxPlaceholder || 'Maximum';
        state.minAttribute = this.props.minAttribute || 'data-minimum';
        state.maxAttribute = this.props.maxAttribute || 'data-maximum';
        state.minHintText = this.props.minHintText || '';
        state.maxHintText = this.props.maxHintText || '';
        state.noMinHintText = this.props.noMinHintText || 'No Min';
        state.noMaxHintText = this.props.noMaxHintText || 'No Max';
        state.preffixText = this.props.preffixText || '';
        state.minimumItemValue = this.props.minimumItemValue || '';
        state.maximumItemValue = this.props.maximumItemValue || '';
        state.minOldVal = this.props.minimumItemValue || '';
        state.minNewVal = '';
        state.maxOldVal = this.props.maximumItemValue || '';
        state.maxNewVal = '';
        if(callSetTarget) state.targetValue = '';
        state.showItems = 'left';
        state.activeTabKey = eventKey;
      }
      else if(parseInt(eventKey,10) === 2){
        state.minValues = this.props.secondMinValues || [];
        state.maxValues = this.props.secondMaxValues || [];
        state.placeholder = this.props.secondPlaceholder || 'Any';
        state.minPlaceholder = this.props.secondMinPlaceholder || 'Minimum';
        state.maxPlaceholder = this.props.secondMaxPlaceholder || 'Maximum';
        state.minAttribute = this.props.secondMinAttribute || 'data-minimum';
        state.maxAttribute = this.props.secondMaxAttribute || 'data-maximum';
        state.minHintText = this.props.secondMinHintText || '';
        state.maxHintText = this.props.secondMaxHintText || '';
        state.noMinHintText = this.props.secondNoMinHintText || 'No Min';
        state.noMaxHintText = this.props.secondNoMaxHintText || 'No Max';
        state.preffixText = this.props.secondPreffixText || '';
        state.minimumItemValue = this.props.secondMinimumItemValue || '';
        state.maximumItemValue = this.props.secondMaximumItemValue || '';
        state.minOldVal = this.props.secondMinimumItemValue || '';
        state.minNewVal = '';
        state.maxOldVal = this.props.secondMaximumItemValue || '';
        state.maxNewVal = '';
        if(callSetTarget) state.targetValue = '';
        state.showItems = 'left';
        state.activeTabKey = eventKey;
      }
      this.setState({ ...state }, () => { if(callSetTarget) {this.setTargetValue();} });
    }
  }

  render(){      
        
    var self = this;

    var minItems = null;
    var maxItems = null;

    if(self.state.showItems && self.state.showItems === 'left'){
      minItems = this.state.minValues.map((val,i) => {
        if(val === 0) {
          return <li key={i} value="" onClick={self.minItemsClickHandler}>Any</li>
        }
        else if(val <= 99999999) {
          return <li key={i} value={val} onClick={self.minItemsClickHandler}>${self.formatNumber(val)}</li>
        }
        else {
          return null;
        }
      });
    }

    if(self.state.showItems && self.state.showItems === 'right'){
      maxItems = this.state.maxValues.map((val,i) => {
        if(val && val !== "" && self.state.minimumItemValue && self.state.minimumItemValue !== "" && 
          parseInt(val,10) < parseInt(self.state.minimumItemValue,10)){
            if(val === 0) {
              return <li key={i} value="" className="disabled">Any</li>
            }
            else if(val <= 99999999) {
              return <li key={i} value={val} className="disabled">${self.formatNumber(val)}</li>
            }
            else {
              return null;
            }
        }
        else{
            if(val === 0) {
              return <li key={i} value="" onClick={self.maxItemsClickHandler}>Any</li>
            }
            else if(val <= 99999999) {
              return <li key={i} value={val} onClick={self.maxItemsClickHandler}>${self.formatNumber(val)}</li>
            }
            else {
              return null;
            }
        }      
      });
    }

    var tabs = (
      <div style={{padding: "8px"}}>
        <div className="input-row">
          <div className="left-column">
              <div className="input-container">
                  <input type="text"
                      ref={(ref) => this.minimumInputRef = ref}
                      name={"minimum"}
                      className="minimum" placeholder={this.state.minPlaceholder}
                      maxLength="11"
                      value={this.state.minimumItemValue !== "" ? "$" + this.formatNumber(this.state.minimumItemValue) : this.state.minimumItemValue}
                      onKeyDown={this.isNumber}
                      onChange={this.minChanged}
                      onFocus={(e) => {self.showListItems('left');self.setState({minOldVal: self.state.minimumItemValue});if(e && e.target){e.target.select();}}}
                      onBlur={() => {self.callCallbackFunctions('min');}} />
              </div>
          </div>
          <div className="mid-column"> - </div>
          <div className="right-column">
              <div className="input-container">
                  <input type="text"
                      ref={(ref) => this.maximumInputRef = ref}
                      name={"maximum"}
                      className="maximum" placeholder={this.state.maxPlaceholder}
                      maxLength="11"
                      value={this.state.maximumItemValue !== "" ? "$" + this.formatNumber(this.state.maximumItemValue) : this.state.maximumItemValue}
                      onKeyDown={this.isNumber}
                      onChange={this.maxChanged}
                      onFocus={(e) => {self.showListItems('right');self.setState({maxOldVal: self.state.maximumItemValue});if(e && e.target){e.target.select();}}}
                      onBlur={() => {self.callCallbackFunctions('max');}} />
              </div>
          </div>
        </div>
        <div className="list-row">
          <div className="list-row-wrapper">
            <div className="left-column">
                <div className="list-items minimum-items">
                    {minItems &&
                      <ul className="list-unstyled">
                        {minItems}
                      </ul>
                    }
                </div>
            </div>
            <div className="right-column">
                <div className="list-items maximum-items">
                  {maxItems &&
                    <ul className="list-unstyled">
                      {maxItems}
                    </ul>
                  }
                </div>
            </div>
          </div>
        </div>
      </div>
    );

    if(this.state.multiTabs) {

      const tlcHeading = (
        <span className="tab_item_header">Monthly TLC <span className="sub_item">( <i className="fa fa-home"></i> + <i className="fa fa-car"></i> + <i className="fa fa-lightbulb-o"></i> + <i className="fa fa-television"></i> )</span></span>
      );
      const priceHeading = (
        <span className="tab_item_header">List price</span>
      ); 

      tabs = (
          <Tabs id="lifestyleTab" activeKey={this.state.activeTabKey} onSelect={(e) => this.onTabSelect(e, false)}>
              <Tab eventKey={1} title={tlcHeading}>
                <div className="input-row">
                  <div className="left-column">
                      <div className="input-container">
                          <input type="text"
                              ref={(ref) => this.minimumInputRef = ref}
                              name={"minimum"}
                              className="minimum" placeholder={this.state.minPlaceholder}
                              maxLength="11"
                              value={this.state.minimumItemValue !== "" ? "$" + this.formatNumber(this.state.minimumItemValue) : this.state.minimumItemValue}
                              onKeyDown={this.isNumber}
                              onChange={this.minChanged}
                              onFocus={(e) => {self.showListItems('left');self.setState({minOldVal: self.state.minimumItemValue});if(e && e.target){e.target.select();}}}
                              onBlur={() => {self.callCallbackFunctions('min');}} />
                      </div>
                  </div>
                  <div className="mid-column"> - </div>
                  <div className="right-column">
                      <div className="input-container">
                          <input type="text"
                              ref={(ref) => this.maximumInputRef = ref}
                              name={"maximum"}
                              className="maximum" placeholder={this.state.maxPlaceholder}
                              maxLength="11"
                              value={this.state.maximumItemValue !== "" ? "$" + this.formatNumber(this.state.maximumItemValue) : this.state.maximumItemValue}
                              onKeyDown={this.isNumber}
                              onChange={this.maxChanged}
                              onFocus={(e) => {self.showListItems('right');self.setState({maxOldVal: self.state.maximumItemValue});if(e && e.target){e.target.select();}}}
                              onBlur={() => {self.callCallbackFunctions('max');}} />
                      </div>
                  </div>
                </div>
                <div className="list-row">
                  <div className="list-row-wrapper">
                    <div className="left-column">
                        <div className="list-items minimum-items">
                            {minItems &&
                              <ul className="list-unstyled">
                                {minItems}
                              </ul>
                            }
                        </div>
                    </div>
                    <div className="right-column">
                        <div className="list-items maximum-items">
                          {maxItems &&
                            <ul className="list-unstyled">
                              {maxItems}
                            </ul>
                          }
                        </div>
                    </div>
                  </div>
                </div>
                
              </Tab>
              <Tab eventKey={2} title={priceHeading}>
                <div className="input-row">
                <div className="left-column">
                    <div className="input-container">
                        <input type="text"
                            ref={(ref) => this.minimumInputRef = ref}
                            name={"minimum"}
                            className="minimum" placeholder={this.state.minPlaceholder}
                            maxLength="11"
                            value={this.state.minimumItemValue !== "" ? "$" + this.formatNumber(this.state.minimumItemValue) : this.state.minimumItemValue}
                            onKeyDown={this.isNumber}
                            onChange={this.minChanged}
                            onFocus={(e) => {self.showListItems('left');self.setState({minOldVal: self.state.minimumItemValue});if(e && e.target){e.target.select();}}}
                            onBlur={() => {self.callCallbackFunctions('min');}} />
                    </div>
                </div>
                <div className="mid-column"> - </div>
                <div className="right-column">
                    <div className="input-container">
                        <input type="text"
                            ref={(ref) => this.maximumInputRef = ref}
                            name={"maximum"}
                            className="maximum" placeholder={this.state.maxPlaceholder}
                            maxLength="11"
                            value={this.state.maximumItemValue !== "" ? "$" + this.formatNumber(this.state.maximumItemValue) : this.state.maximumItemValue}
                            onKeyDown={this.isNumber}
                            onChange={this.maxChanged}
                            onFocus={(e) => {self.showListItems('right');self.setState({maxOldVal: self.state.maximumItemValue});if(e && e.target){e.target.select();}}}
                            onBlur={() => {self.callCallbackFunctions('max');}} />
                    </div>
                </div>
              </div>
              <div className="list-row">
                <div className="list-row-wrapper">
                  <div className="left-column">
                      <div className="list-items minimum-items">
                          {minItems &&
                            <ul className="list-unstyled">
                              {minItems}
                            </ul>
                          }
                      </div>
                  </div>
                  <div className="right-column">
                      <div className="list-items maximum-items">
                        {maxItems &&
                          <ul className="list-unstyled">
                            {maxItems}
                          </ul>
                        }
                      </div>
                  </div>
                </div>
              </div>
            </Tab>
          </Tabs>
      );  
    }
    
    

    const popoverObj = (
      <Popover id={this.state.cssClass + "-popover"} className="smart-range-popover new_tlc_toggle">
          <ReactTooltip />
          <div className={"smartrange"}>
              <div className="lifestyle_box">
                {!this.state.showTooltip && tabs}
                {/* this.props && this.props.infoText && this.props.infoText !== '' &&              
                <div className="info-row">
                  <i className="fa fa-question-circle" data-html={true} data-class="tooltip_box" data-tip={this.props.infoText}></i>
                </div> */}
                {this.state.showTooltip &&
                  <div className="tlc_what_popup">
                    <div className="gray_bg_text">How much do you have to spend each month on your living costs?</div>
                    <div className="what_tlc_text">
                        <span>True Lifestyle Cost (TLC) is the monthly budget range that takes into account your mortgage, taxes and insurance, but also costs such as entertainment, utilities, homeowners insurance, gas pricing, commuting, and other factors contributing to your total cost of home ownership.</span>
                        <span>If you’re curious, each property page breaks down the cost of each expense as it’s predicted for that property.</span>
                    </div>
                    <div className="close_popup" onClick={this.showHideTooltip}><i className="fa fa-times-circle"></i></div>
                  </div>
                }                
              </div>
              {this.props && this.props.tooltipText && this.props.tooltipText !== '' &&
              <div className="info-row">                
                {this.props && this.props.infoText && this.props.infoText !== '' &&
                    this.props.infoText
                }
                {/* <div className={this.state.showTooltip ? "info-text orange_bg" : "info-text"} onClick={this.showHideTooltip} data-html={true} data-class="tooltip_box" data-tip={this.props.tooltipText}>What is TLC?</div> */}
                <div className={this.state.showTooltip ? "info-text orange_bg" : "info-text"} onClick={this.showHideTooltip}>What is True Lifestyle Cost (TLC)?</div>
              </div>
              }
              <div style={{clear:"both"}}></div> 
          </div>
      </Popover>
    );

    return (
      <OverlayTrigger trigger="click" placement="bottom" rootClose overlay={popoverObj} onEntered={this.openPopup}>
        <div>
        {this.state.cssClass !== 'tru-input' &&
          <div className={this.state.cssClass}>
            <span>{this.state.targetValue}</span>
          </div>
        }
        {this.state.cssClass === 'tru-input' &&
          <input className={`tru-input ${this.state.targetValue === 'Lifestyle Cost (Monthly)' ? '': 'tru-input-ph' }`} 
            placeholder={this.state.targetValue} readOnly />
        }
        </div>
      </OverlayTrigger>
    );
  }

}
